/** Dados mínimos de uma pessoa para exibição em telas e relatórios. */
export type PessoaExib =
  | {
      apelido?: string | null;
      nome?: string | null;
      email?: string | null;
    }
  | null
  | undefined;

/**
 * Nome curto usado em listagens e relatórios:
 * apelido → nome → parte do e-mail antes do "@".
 */
export function nomeExib(p: PessoaExib, vazio = "—"): string {
  const apelido = (p?.apelido ?? "").trim();
  if (apelido) return apelido;
  const nome = (p?.nome ?? "").trim();
  if (nome) return nome;
  const email = (p?.email ?? "").trim();
  if (email) return email.split("@")[0] ?? email;
  return vazio;
}
